import { CommonModule } from '@angular/common';
import { LOCALE_ID, NgModule } from '@angular/core';

import { VendorsModule } from '@my-aon/vendors';

import { ToastrModule } from 'ngx-toastr';
import { ComponentsModule } from './components/components.module';
import { DirectivesModule } from './directives/directives.module';
import { PipesModule } from './pipes/pipes.module';


@NgModule({
    imports: [
        CommonModule,
        ComponentsModule,
        DirectivesModule,
        PipesModule,
        VendorsModule,
        ToastrModule.forRoot()
    ],
    exports: [
        ComponentsModule,
        DirectivesModule,
        PipesModule,
        VendorsModule,
    ],
    providers: [
        { provide: LOCALE_ID, useValue: 'pt-PT' },
    ]
})
export class SharedModule { }
